import React, { useRef, useEffect } from 'react';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { observer } from 'mobx-react';
import { Table } from 'reactstrap';
import { ActivitySummaryVM } from './ActivitySummaryVM';
import { formatDate } from 'cd-eft/utils/formatDate';
import './ActivitySummary.scss';

const ActivitySummaryComponent = (props) => {
  const vm = useRef(new ActivitySummaryVM(props)).current;

  useEffect(() => {
    vm.getActivitySummary(props.projectId);
  }, [props.projectId]);

  return (
    <div className="activity-summary-contanier">
      <Accordion className="activity-summary-accordion-wrapper" headers={['Activity Summary']} >
        <div className="table-wrapper height-auto">
          <Table className="activity-summary-table m-0">
            <thead>
              <tr className="activity-header">
                <th className="header1">Category</th>
                <th className="header2">Name</th>
                <th className="header3">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Created By</td>
                <td>{vm.activitySummary.createdBy}</td>
                <td>{vm.activitySummary.createdDate ? formatDate(vm.activitySummary.createdDate) : null}</td>
              </tr>
              <tr>
                <td>Approved By</td>
                <td>{vm.activitySummary.approvedBy}</td>
                <td>{vm.activitySummary.approveDate ? formatDate(vm.activitySummary.approveDate) : null}</td>
              </tr>
              <tr>
                <td>Last Modified By</td>
                <td>{vm.activitySummary.lastModifiedBy}</td>
                <td>{vm.activitySummary.lastModifiedDate ? formatDate(vm.activitySummary.lastModifiedDate) : null}</td>
              </tr>
              <tr>
                <td>Last Reviewed By</td>
                <td>{vm.activitySummary.lastReviewedBy}</td>
                <td>{vm.activitySummary.lastReviewedDate ? formatDate(vm.activitySummary.lastReviewedDate) : null}</td>
              </tr>
              <tr>
                <td>Last Access Date</td>
                <td>{vm.activitySummary.lastAccessedBy}</td>
                <td>{vm.activitySummary.lastAccessedDate ? formatDate(vm.activitySummary.lastAccessedDate) : null}</td>
              </tr>
              <tr>
                <td>Designed By</td>
                <td>{vm.activitySummary.designedBy}</td>
                <td>{vm.activitySummary.designedDate ? formatDate(vm.activitySummary.designedDate) : null}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Accordion>
    </div>
  );
};
export const ActivitySummary = observer(ActivitySummaryComponent);
